import { Tabs, TabList, Tab } from "@similarweb/ui-components";
import { Text } from "@similarweb/ui-components/foundations";

import { EErrorTypes } from "app/components/React/empty-state/GenericEmptyState";

import { MetricsWidgetContainer } from "../MetricsWidgetContainer";
import type { MetricsWidgetContainerProps } from "../MetricsWidgetContainer";

import type { MetricWidgetLineGraphProps } from "./MetricWidgetLineGraph";
import { MetricWidgetLineGraph } from "./MetricWidgetLineGraph";

type MetricWidgetLineGraphContainerProps = MetricWidgetLineGraphProps &
    Pick<MetricsWidgetContainerProps, "title" | "automationId" | "isLoading"> & {
        isError?: boolean;
        selectedTabIndex: number;
        onTabSelect: (index: number) => void;
        tabs: { id: string; label: string; dataAutomation: string }[];
    };

export const MetricWidgetLineGraphContainer = ({
    automationId,
    data,
    isError,
    isLoading,
    isMonthly,
    legendHeaders,
    onTabSelect,
    selectedTabIndex,
    tabs,
    title,
}: MetricWidgetLineGraphContainerProps) => (
    <MetricsWidgetContainer
        title={title}
        automationId={automationId}
        isLoading={isLoading}
        noData={!isLoading ? !data.length : undefined}
        noDataType={isError ? EErrorTypes.ERROR : EErrorTypes.NO_DATA}
    >
        <Tabs
            selectedIndex={selectedTabIndex}
            onSelect={onTabSelect}
        >
            <TabList>
                {tabs.map(({ id, label, dataAutomation }) => (
                    <Tab
                        key={id}
                        data-automation={dataAutomation}
                    >
                        <Text fontVariant="tab">{label}</Text>
                    </Tab>
                ))}
            </TabList>
        </Tabs>

        <MetricWidgetLineGraph
            data={data}
            isMonthly={isMonthly}
            legendHeaders={legendHeaders}
        />
    </MetricsWidgetContainer>
);
